import Logo from '../logos/pluggit';

export default Logo;
